// utils/eta.js
// Returns a display ETA like "3:00 PM" using order.property.checkInTime first,
// and falls back to the time component of order.inStockDate if present.
// Never invents a random time; returns null if no reliable time is found.

import { format } from "date-fns";

/** Formats an ISO-8601 string into 
 *  “Month DaySuffix, Year HH:MM AM/PM” */
 function formatDate(isoString) {
    if (!isoString) return '—';
    const [datePart, timePart] = isoString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hourRaw, minuteRaw] = timePart.split(':');
    const h = parseInt(hourRaw, 10), m = minuteRaw;
    const hour12 = h % 12 || 12;
    const ampm = h >= 12 ? 'PM' : 'AM';
    const suffix =
      ['11','12','13'].includes(day) ? 'th'
      : day.endsWith('1')               ? 'st'
      : day.endsWith('2')               ? 'nd'
      : day.endsWith('3')               ? 'rd'
      : 'th';
    const names = [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ];
    return `${names[parseInt(month,10) - 1]} ${parseInt(day,10)}${suffix}, ${year} ` +
           `${hour12}:${m} ${ampm}`;
  }
  
export function etaFromOrder(order) {
  // 1) Preferred: explicit property check-in time
  const fromProperty = order?.property?.checkInTime;
  if (fromProperty) return fromProperty;

  // 2) Fallback: time portion in inStockDate (if present)
  const fromInStock = formatDate(order?.inStockDate);
  if (fromInStock) return fromInStock;

  // 3) No reliable time
  return null;
}
